import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { btn, field } from "@/components/ui-kit";

export const ClearLogDialog = ({ open, onOpenChange, onDone }) => {
  const [days, setDays] = useState(30);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.delete("/edi/messages", { params: { older_than_days: Number(days) } });
      toast.success(`${r.data.deleted} message(s) cleared from the log`);
      onDone();
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md border-slate-800 bg-[#1F232C] text-slate-100" data-testid="clear-log-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Clear EDI log</DialogTitle>
          <DialogDescription className="text-slate-400">Deletes inbound and outbound messages older than the number of days below. Orders, stock and unsent outbound messages are kept. This cannot be undone.</DialogDescription>
        </DialogHeader>
        <label className="block">
          <span className="mb-1 block font-mono text-[10px] uppercase tracking-wider text-slate-500">Older than (days)</span>
          <Input type="number" min={1} value={days} onChange={(e) => setDays(e.target.value)} className={field} data-testid="clear-log-days-input" />
        </label>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)} className={btn.ghost} data-testid="clear-log-cancel-btn">Cancel</Button>
          <Button onClick={run} disabled={busy || Number(days) < 1} className="bg-red-600 text-white hover:bg-red-500" data-testid="clear-log-confirm-btn">Clear messages</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
